import { getAuthenticatedRequestInit } from './utils';

export const GetNotes = (token: string, meeting: number) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notes/${meeting}`, {
		method: 'GET',
		...getAuthenticatedRequestInit(token),
	}).then(result => {
		if (result.ok) {
			return result.json();
		} else {
			throw new Error(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notes/${meeting}`);
		}
	});
};

export const GetAllNotes = (token: string) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notes/all`, {
		method: 'GET',
		...getAuthenticatedRequestInit(token),
	}).then(result => {
		if (result.ok) {
			return result.json();
		} else {
			throw new Error(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notes`);
		}
	});
};

export const CreateNote = (token: string, meeting: number, fromGlobal?: boolean) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notes/create`, {
		method: 'POST',
		body: JSON.stringify({
			meeting,
		}),
		...getAuthenticatedRequestInit(token),
	}).then(async result => {
		if (result.ok) {
			const results = await result.json();
			return [results, fromGlobal];
		} else {
			throw new Error(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notes/save could not save`);
		}
	});
};


export const SaveNote = (token: string, meeting: number, title: string, content: string, content_text: string, shared_with: string | null, id?: number) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notes/save`, {
		method: 'POST',
		body: JSON.stringify({
			id,
			meeting,
			title,
			content,
			content_text,
			shared_with,
		}),
		...getAuthenticatedRequestInit(token),
	}).then(result => {
		if (result.ok) {
			return result.json();
		} else {
			throw new Error(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notes/save could not save`);
		}
	});
};

export const DeleteNote = (token: string, id: number) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notes/${id}`, {
		method: 'DELETE',
		...getAuthenticatedRequestInit(token),
	}).then(result => {
		if (result.ok) {
			return result.json();
		} else {
			throw new Error(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notes/${id}`);
		}
	});
};

export const UndeleteNote = (token: string, id: number) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notes/${id}`, {
		method: 'PUT',
		...getAuthenticatedRequestInit(token),
	}).then(result => {
		if (result.ok) {
			return result.json();
		} else {
			throw new Error(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notes/${id}`);
		}
	});
};

export const AddToMeeting = (token: string, meeting: number, id: number) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notes/${id}/${meeting}`, {
		method: 'PUT',
		...getAuthenticatedRequestInit(token),
	}).then(result => {
		return { id, meeting };
	});
};

export const RemoveFromToMeeting = (token: string, meeting: number, id: number) => {
	return fetch(`${process.env.REACT_APP_API_HOST}/v2/greenroom/notes/${id}/${meeting}`, {
		method: 'DELETE',
		...getAuthenticatedRequestInit(token),
	}).then(result => {
		return { id, meeting };
	});
};
